import React from 'react'
import { AlertCircle } from 'lucide-react'

export const ErrorState = ({ title, message, onRetry, retryText = "Go to Login" }) => {
  return (
    <div className="min-h-screen flex justify-center items-center bg-gradient-to-br from-gray-50 via-white to-gray-100">
      <div className="text-center max-w-md mx-auto p-8 bg-white rounded-2xl shadow-xl border border-gray-200">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertCircle className="w-8 h-8 text-red-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-4">{title}</h2>
        <p className="text-gray-600 mb-6">{message}</p>
        <button
          onClick={onRetry}
          className="px-6 py-3 bg-teal-500 text-white rounded-xl hover:bg-teal-600 transition duration-200 font-medium"
        >
          {retryText}
        </button>
      </div>
    </div>
  )
}